import m from "./../../../dist/es2015/locales/vi_VN.js";
export const am5locales_vi_VN = m;